import React from 'react'

function RefundPolicy() {
  return (
    <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 main_content_terms">
            <div className="row justify-content-center">
                <div className="col-12 text-center my-5">
                    <h1>Refund Policy</h1>
                </div>
                <div className="col-lg-10 col-11">
                    <div className="row pb-3">
                        <p>Thank you for your purchase. Please note that all sales are final, and we do not offer refunds for any payments made.</p>
                        <p>We encourage you to review your order carefully before completing your transaction. If you have any questions or need assistance, please don’t hesitate to reach out to our support team at <a target="_blank" rel="noopener noreferrer" href="mailto:support@loov.in">support@loov.in</a>.</p>
                        <p>By proceeding with your purchase, you acknowledge and agree to this no-refund policy.</p>
                    </div>
                </div>
            </div>
          </div>
          
        </div>
    </div>
  )
}

export default RefundPolicy
